import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

import { AlarmProfilesDrawerModal } from "@src/components/organisms/modals/alarm-profiles-drawer-modal/alarm-profiles-drawer-modal";

export const AlarmProfilesDrawer = () => {
  const showAlarmProfilesDrawerModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.alarmProfilesDrawerModal.showModal,
  );

  return <>{showAlarmProfilesDrawerModal && <AlarmProfilesDrawerModal />}</>;
};
